export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8763.d6c47f8e.jpg";